import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "1.66504",
      y: "1.66504",
      width: "16.67",
      height: "16.67",
      rx: "8.335",
      fill: "#ACD1F8"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.0008 10.7522C9.92558 10.7522 9.85033 10.7349 9.78088 10.6944L4.6699 7.73659C4.46731 7.61504 4.39207 7.34878 4.51362 7.14041C4.63517 6.93203 4.90143 6.86258 5.1098 6.98413L10.0008 9.81455L14.8629 7.00149C15.0713 6.87994 15.3375 6.95519 15.4591 7.15777C15.5806 7.36615 15.5054 7.63241 15.3028 7.75396L10.2266 10.6944C10.1513 10.7291 10.0761 10.7522 10.0008 10.7522Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.0008 15.9963C9.76345 15.9963 9.56665 15.7995 9.56665 15.5622V10.3123C9.56665 10.075 9.76345 9.87817 10.0008 9.87817C10.2381 9.87817 10.4349 10.075 10.4349 10.3123V15.5622C10.4349 15.7995 10.2381 15.9963 10.0008 15.9963Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.0007 16.2222C9.49136 16.2222 8.98779 16.1122 8.5884 15.8923L5.4975 14.1732C4.65822 13.7101 4.00415 12.593 4.00415 11.6322V8.36184C4.00415 7.401 4.65822 6.28966 5.4975 5.82082L8.5884 4.10751C9.38138 3.66761 10.6201 3.66761 11.413 4.10751L14.5039 5.82661C15.3432 6.28966 15.9973 7.40679 15.9973 8.36763V11.638C15.9973 12.5988 15.3432 13.7101 14.5039 14.179L11.413 15.8923C11.0137 16.1122 10.5101 16.2222 10.0007 16.2222ZM10.0007 4.64582C9.63606 4.64582 9.27719 4.72106 9.01094 4.86577L5.92004 6.58486C5.36438 6.89164 4.87238 7.72514 4.87238 8.36184V11.6322C4.87238 12.2689 5.36438 13.1024 5.92004 13.4149L9.01094 15.134C9.53766 15.4292 10.4638 15.4292 10.9905 15.134L14.0814 13.4149C14.6371 13.1024 15.1291 12.2747 15.1291 11.6322V8.36184C15.1291 7.72514 14.6371 6.89164 14.0814 6.57907L10.9905 4.85998C10.7242 4.72106 10.3654 4.64582 10.0007 4.64582Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }